module.exports = __webpack_public_path__ + "static/img/redPackageBg.76ee9f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/redPackageBg.png
// module id = vd0I
// module chunks = 1